import { Compiler, Component, OnInit, SystemJsNgModuleLoader } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
    ITCITenantComponentOptions,
    ITCIUserInfo,
    TCI_TOOLS_ENV_TYPE,
    TCIMainMenu,
    TCITenantAppType,
    TCITenantEnvTools
} from "@tci/common";
import { AbstractTciTenantComponentLoader } from "../../ng-tenant/tci-tenant-component-loader.component";
import {
    ITCICEnvToolsComponentOutput,
    ITCIEnvToolsComponentInput,
    TCITenantComponentInput,
    TCITenantComponentOutput
} from "../../ng-tenant/tci-tenant-components";
import { TCITenantRemoteServices } from "../../ng-tenant/tci-tenant-remote-services";
import { TciTenantService } from "../../ng-tenant/tci-tenant.service";
import { TCITenantLoaderComponent } from "../../ng-tenant/tci-tenant-component";
import { TciTenantModelService } from "../../ng-tenant/tci-tenant.model";
import { NgUserService } from "../../ng-shared/ng-services/ng-user.service";
import { NgAppFeatureToggleService } from "../../ng-shared/ng-services/ng-app-feature-toggle.service";
import { NgWaitService } from "../../ng-shared/ng-components/ng-wait/ng-wait.service";

import { Observable } from "rxjs";
import {
    ITCITenantCacheOptions,
    ITCITenantCompCache,
    TciTenantComponentCacheService
} from "../../ng-tenant/tci-tenant-component-cache.service";

/****************************************************************************************************/
/*                                Dynamic Component                                                 */

/****************************************************************************************************/
export class NgEnvToolsComponentInput extends TCITenantComponentInput implements ITCIEnvToolsComponentInput {
    constructor(protected tenantType: TCITenantAppType,
        protected userService: NgUserService,
        protected featureToggleService: NgAppFeatureToggleService,
        protected option: ITCITenantComponentOptions<TCI_TOOLS_ENV_TYPE>) {
        super();
        const tenantTypes = option.getTenantTypes();
        this.tenantAppType = tenantTypes.length > 0 ? TCITenantAppType.createPseudoTenant(...tenantTypes) : tenantTypes[0];
        this.componentSelector = option.getComponentSelectorType();
    }

    public getOption(): ITCITenantComponentOptions<TCI_TOOLS_ENV_TYPE> {
        return this.option;
    }

    public getUserInfo(): Observable<ITCIUserInfo> {
        return this.userService.getUserInfo(false);
    }
}

class NgSecurityComponentOutput extends TCITenantComponentOutput<string> implements ITCICEnvToolsComponentOutput<string> {
    constructor() {
        super();
    }
}

// Extended class for the Tenant Component Loader
@TCITenantLoaderComponent({
    isdynamic: true
})
@Component({
    selector: "ng-env-tools-dyn-cmp",
    template: "<template #dynamic></template>"
})
export class NgEnvToolsDynLoaderComponent
    extends AbstractTciTenantComponentLoader<string, ITCIEnvToolsComponentInput, ITCICEnvToolsComponentOutput<string>> {
    constructor(
        loader: SystemJsNgModuleLoader,
        compiler: Compiler,
        tenantRemoteServices: TCITenantRemoteServices,
        tenantSvc: TciTenantService,
        tenantModelSvc: TciTenantModelService
    ) {
        super(loader, compiler, tenantRemoteServices, tenantSvc, tenantModelSvc);
    }
}

// The main component
@Component({
    templateUrl: "./ng-env-tools-loader.component.html",
    styleUrls: ["./ng-env-tools-loader.component.css", "../ng-env-tools.component.css"]
})
export class NgEnvToolLoaderComponent implements OnInit {
    ready = false;
    routeid: string;
    title: string;
    private tenantComponentInput: NgEnvToolsComponentInput;

    constructor(
        private route: ActivatedRoute,
        private tenantSvc: TciTenantService,
        private userService: NgUserService,
        private featureToggleService: NgAppFeatureToggleService,
        private cacheSvc: TciTenantComponentCacheService,
        private blockUiService: NgWaitService
    ) {
        this.route.params.subscribe(params => {
            this.routeid = params.routeid;
            this.tenantSvc.onInit().subscribe(() => {
                this.ready = true;
                this.mountComponent();
            });
        });
    }

    ngOnInit(): void { }

    mountComponent() {
        const option: ITCITenantComponentOptions<string | number> = TCITenantEnvTools
            .getAllItems()
            .find(tool => tool.getRouteId() === this.routeid);

        if (option) {
            this.blockUiService.block();

            // Find the tenants that apply for the component and load the modules
            const cacheObs: Observable<ITCITenantCompCache>[] = option.getTenantTypes()
                .map(tenantType => {
                    const opts: ITCITenantCacheOptions = {
                        routeId: TCIMainMenu.MAIN_MENU_ENV_TOOLS.getRouteId(),
                        tenantType
                    };

                    return this.cacheSvc.getCache(false, opts);
                });

            Observable.merge(...cacheObs)
                .toArray()
                .subscribe(res => {
                    // By this moment all the env-controls modules from related tenants are loaded
                    this.blockUiService.unblock();
                    this.tenantComponentInput = new NgEnvToolsComponentInput(
                        TCITenantAppType.createPseudoTenant(...TCITenantAppType.getAllTypes()),
                        this.userService,
                        this.featureToggleService,
                        option
                    );
                    this.title = this.tenantComponentInput.getOption().getLabel();
                });
        } else {
            console.log("Wrong params!", this.routeid);
        }
    }
}
